import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

export function SkipToDestination({ children, reference }) {
  return (
    <div ref={reference} tabIndex="0">
      {children}
    </div>
  );
}

SkipToDestination.propTypes = {
  children: PropTypes.node,
  reference: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};

export function SkipToContent({ reference }) {
  const [focused, setFocus] = useState(false);

  const onClick = (event) => {
    event.preventDefault();
    setFocus(false);
    reference.current.focus();
  };

  const onFocus = () => {
    setFocus(true);
  };

  const onBlur = () => {
    setFocus(false);
  };

  return (
    <LinkStyles
      href="#"
      $isFocused={focused}
      onClick={onClick}
      onFocus={onFocus}
      onBlur={onBlur}
    >
      Skip to content
    </LinkStyles>
  );
}

SkipToContent.propTypes = {
  reference: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};

const LinkStyles = styled.a`
  position: absolute;
  top: var(--sm);
  left: ${(props) => (props.$isFocused ? `50%;` : `-1000px;`)}
  background-color: white;
  width: 200px;
  z-index: 1;
  margin-left: -100px;
  text-align: center;
  padding: var(--md) 0;
  font-weight: bold;
`;
